import { render } from "./step2.vue?vue&type=template&id=339de5ad&scoped=true"
import script from "./step2.vue?vue&type=script&lang=js"
export * from "./step2.vue?vue&type=script&lang=js"

import "./step2.vue?vue&type=style&index=0&id=339de5ad&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-339de5ad"]])

export default __exports__